import PropTypes from 'prop-types';

import SvgImg from '../SvgImg';

function VehicleIcon({
  style,
  className,
  type = null,
  subType,
  description,
}) {
  let src;

  if (!subType) {
    let filename;
    switch (type) {
      case 'car':
        filename = 'hatchback';
        break;
      case 'utility':
        filename = 'vanPro';
        break;
      case 'truck':
        filename = 'truck';
        break;
      case 'transport':
        filename = 'van';
        break;
      case 'motorbike':
        filename = 'street';
        break;
      default: filename = undefined;
    }
    src = (filename)
      ? `/images/svg/gui/vehicles/${filename}.svg`
      : '/images/svg/gui/empty.svg';

    return (
      <SvgImg
        style={style}
        className={className}
        description={description}
        src={src}
      />
    );
  }

  src = `/images/svg/gui/vehicles/${subType}.svg`;

  return (
    <SvgImg
      style={style}
      className={className}
      src={src}
      description={description}
    />
  );
}

VehicleIcon.propTypes = {
  style: PropTypes.shape({ }),
  className: PropTypes.string,
  type: PropTypes.string,
  subType: PropTypes.string,
  description: PropTypes.string,
};

export default (VehicleIcon);
